import { Tooltip, Typography } from '@mui/material';

import { ChainUptimeResult } from 'domains/status/utils/calculateChainUptime';

import { ChainStatusItem } from './ChainStatusItem';
import { useChainDescriptionStyles } from '../../useChainDescriptionStyles';

interface IChainStatusTooltipProps {
  currentChainStatuses: ChainUptimeResult[];
}

export const ChainStatusTooltip = ({
  currentChainStatuses,
}: IChainStatusTooltipProps) => {
  const { classes } = useChainDescriptionStyles();

  return (
    <Tooltip
      placement="top"
      className={classes.tooltip}
      classes={{
        tooltip: classes.tooltipContent,
      }}
      title={
        <div>
          {currentChainStatuses.map(chainStatus => (
            <ChainStatusItem
              className={classes.statusItem}
              key={chainStatus.chainPath}
              chainStatus={chainStatus}
            />
          ))}
        </div>
      }
    >
      <Typography variant="body4" className={classes.statusText}>
        Chain status
      </Typography>
    </Tooltip>
  );
};
